module["exports"] = [
  "#{street_prefix} #{Name.last_name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pl/address/street_name.js
// module id = 1398
// module chunks = 1